<gpu-radio-group formControlName="value" (ngModelChange)="track()">
  <gpu-radio-button
    *ngFor="let answer of question.answers; let i = index"
    id="option_{{ i }}_{{ answer.id }}"
    name="value{{ i }}"
    class="gmt-12 gmb-24 d-block"
    [value]="answer.id"
  >
    {{ answer.name }}
  </gpu-radio-button>
</gpu-radio-group>
